import { motion, useSpring, useTransform } from "motion/react";
import { useEffect } from "react";

/**
 * Counts from its previous value to the next whenever `value` changes, instead
 * of hard-cutting the DOM text. This is the one authored motion moment repeated
 * everywhere numbers update — a spring, not scattered per-page effects.
 */
export function AnimatedNumber({
  value,
  format,
  className,
}: {
  value: number;
  format?: (n: number) => string;
  className?: string;
}) {
  const spring = useSpring(value, { stiffness: 120, damping: 20, mass: 0.5 });
  const display = useTransform(spring, (v) => (format ? format(v) : Math.round(v).toLocaleString("de-AT")));

  useEffect(() => {
    spring.set(value);
  }, [value, spring]);

  return <motion.span className={className}>{display}</motion.span>;
}
